<template>
    <div :id="LastViewedState(accolade.AccoladeID)" class="btn btn-accolade m-span" @click="View(accolade.AccoladeID)" @mouseenter="Hover(true)" @mouseleave="Hover(false)">
        <div class="m-span titles">
            <p class="title">{{ accolade.Title }}</p>
            <p class="sub-title" v-if="accolade.SubTitle">{{ accolade.SubTitle }}</p>
            <p class="granter">{{ GranterYearLabel() }}</p>
        </div>
        <div class="image">
            <img class="row" :src="ImageSource()" :alt="Label()" :title="Label()"/>
        </div>
        <div class="m-hide single sources-list span" v-if="(URLSourcesExist() && showURLSourcesList) && CONFIG.showURLSourcesList">
            <p class="heading"><b>Additional Sources</b></p>
            <p v-for="(source, s) in accolade.AccoladeSourceDetails.Sources" :key="s">
                <span class="btn link" @click="View('File', source)">{{ source.Type }}</span>
            </p>
        </div>
    </div>
</template>

<script>
import { FormattedDate } from "@/assets/JS/Master.js";
import { ASSETS } from "@/assets/JS/Assets.js";
import { CONFIG } from "@/assets/JS/Config.js";
import $ from "jquery";

export default {
    name: "Accolades",
    props: {
        accolade: Object,
        mobile: Boolean,
        collection: String
    },
    data: () => ({
        showURLSourcesList: false,
        CONFIG
    }),
    methods: {
        ImageSource: function() {
            return require(`@/assets/Images/Accolades/${this.collection}/${this.accolade.AccoladeID}/Thumb/${this.accolade.ImageSource}`);
        },
        Label: function() {
            const { Title, SubTitle } = this.accolade;
            const subTitle = SubTitle ? ` - ${SubTitle}` : "";
            return `Accolade - ${Title}${subTitle}`;
        },
        URLSourcesExist: function() {
            // return this.accolade.URL.Sources !== null;
            const { Sources } = this.accolade.AccoladeSourceDetails;
            return Sources !== null && Sources.length > 0;
        },
        View: function(accoladeID) {
            let accoladeNavigation = ASSETS.GetStorage("PortfolioAccoladeNavigation");
            if (accoladeNavigation) {
                accoladeNavigation = {
                    ...accoladeNavigation,
                    accoladeID
                };
            }
            ASSETS.SetStorage("PortfolioAccoladeNavigation", accoladeNavigation);
            this.$router.push({
                name: "Accolade",
                params: { accoladeID }
            });
        },
        GranterYearLabel: function() {
            const { Granter, Month, Day, Year } = this.accolade;
            let date;
            if (Month && Year && !Day) {
                date = new FormattedDate("Two Part", `${Month}/1/${Year}`).singleOutput;
            } else if (Year && (!Month && !Day)) {
                date = Year;
            } else if (Month && Day && Year) {
                date = new FormattedDate("Descriptive", `${Month}/${Day}/${Year}`).singleOutput;
            }
            if (this.accolade.Granter) {
                return `${Granter}, ${date}`;
            } else {
                return date;
            }
        },

        // Check if external URL should use configuration host
        CheckConfigurationHostUsage: function(source, rootURL) {
            if (source.indexOf("{host}") !== 1) {
                source = source.replace("{host}", rootURL);
            }
            return source;
        },

        Hover: function(over) { this.showURLSourcesList = over; },
        LastViewedState: function(accoladeID) {
            const accoladeNavigation = ASSETS.GetStorage("PortfolioAccoladeNavigation");
            let lastViewedAccoladeID = -1;
            if (accoladeNavigation) {
                lastViewedAccoladeID = accoladeNavigation.accoladeID;
            }
            if (lastViewedAccoladeID !== -1) {
                return lastViewedAccoladeID === accoladeID ? "accolade-last-viewed" : "";
            }
        }
    },
    mounted: function() {
        const $lastViewed = $("#accolade-last-viewed");
        if ($lastViewed.length) {
            this.$emit("last-viewed-top-position", Math.floor($("#accolade-last-viewed").offset().top));
        }
    },
    emits: [ "last-viewed-top-position" ]
};
</script>